import { render, staticRenderFns } from "./LimitInput.vue?vue&type=template&id=4d525b98"
import script from "./LimitInput.vue?vue&type=script&lang=js"
export * from "./LimitInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports